import { isExternalAuth } from '@/lib/auth/external-auth'
import { initCWTracks } from '@/lib/auth/init-cwtracks'
import auth from '@/lib/auth/oAuth'
if (!isExternalAuth()) {
  auth.init()
  //挂载 App
  import(
    /* webpackChunkName: "index-async" */
    './index.async'
  )
} else {
  initCWTracks()
}
